import axios from 'axios';

export default class CoverService {

  static deleteCover(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/coverImages/${id}`)
        .then((res) => {
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }
  static createCover(formData: FormData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/coverImages',
            formData,
            { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/CoverService.ts